import { Fragment } from "react";
import { Outlet } from "react-router-dom";

const HRindex = () => {
  return (
    <Fragment>
      <Outlet />
    </Fragment>
  );
};

export default HRindex;
